import React from "react";
import styles from "./Card.scss";

const Card = ({
  title,
  className,
  headerContent,
  children,
  bodyClassName,
  headerClassName,
}) => {
  return (
    <div className={`card ${className || ""}`}>
      {title &&
      <div
        className={`card_header ${headerContent ? "with_content" : ""} ${
          headerClassName || ""
        }`}
      >
        <h3>{title}</h3>
        {headerContent && (
          <>
            <div className="card_header_content">{headerContent}</div>
          </>
        )}
      </div>
      }
      <div className={`card_body ${bodyClassName || ""}`}>{children}</div>
    </div>
  );
};

export default Card;
